import React from 'react'
interface loadProps {
  message?: string,
  classes?: string
}
const LoadingComponent = (props:loadProps) => {

  return (
    <div className={`sopa--map-loader ${props.classes}`}>
      <span className="material-icons nsw-material-icons">hourglass_empty</span>
      <p>{props.message ? props.message : "Loading data, please wait"}</p>
    </div>

  )
}

export default LoadingComponent
